// extracted by mini-css-extract-plugin
module.exports = {"paypal_placeholder":"styles_paypal_placeholder__Ug7xp","button-loading-spinner":"styles_button-loading-spinner__IvuTo"};